export default __webpack_public_path__ + "static/media/links-plaque.19ba731d.png";